import { basicResetReducer } from '@ackee/redux-utils';
import { AUTH_SESSION_END } from '@ackee/petrus';

import { apiReducer } from 'modules/entities';

export default basicResetReducer(apiReducer, AUTH_SESSION_END);
